import api from "../services/api";

export const createAdminUser = async (data) => {
    try {
        const response = await api.post(`/admin/register`, data);
        return response;
    } catch (error) {
        console.error('Erro ao criar conta:', error?.response?.data);
        throw error;
    }
}

export const getAllAdminUsers = async () => {
    try {
        const response = await api.get(`/admin/users`);
        return response;
    } catch (error) {
        console.error('Erro ao exibir usuários:', error?.response?.data);
        throw error;
    }
}

export const adminUserEdit = async (id, data) => {
    try {
        const response = await api.patch(`/admin/${id}/`, data);
        console.log(response?.data);
        return response;
    } catch (error) {
        console.error('Erro ao editar usuário:', error?.response?.data);
        throw error;
    }
}

export const updateSubscription = async (id, data) => {
    try {
        const response = await api.put(`/admin/subscription/${id}`, data);
        console.log(response?.data);
        return response;
    } catch (error) {
        console.error('Erro ao atualizar subscrição:', error?.response?.data);
        throw error;
    }
}

export const getAdminSelected = async (id) => {
    try {
        const response = await api.get(`/admin/${id}`);
        return response;
    } catch (error) {
        console.error('Erro ao obter usuário:', error?.response?.data);
        throw error;
    }
}

export const deleteAdminUser = async (id) => {
    try {
        const response = await api.delete(`/admin/delete/${id}`);
        return response;
    } catch (error) {
        console.error('Erro ao deletar usuário:', error?.response?.data);
        throw error;
    }
}